import axios from 'axios';

export default function initInterceptors() {
  axios.interceptors.response.use(
    (config) => config,
    (err) => {
      const errContent = handleErrors(err);
      return Promise.reject(errContent);
    }
  );
}

function getManualRetryCount() {
  return JSON.parse(window.localStorage.getItem('manualRetry'));
}

function trackErrorsShown() {
  let errorsShown = JSON.parse(window.localStorage.getItem('errorsShown'));

  if (!errorsShown || errorsShown <= 1) {
    errorsShown >= 1 ? window.localStorage.setItem('errorsShown', (errorsShown += 1)) : window.localStorage.setItem('errorsShown', 1);
  }

  return errorsShown;
}

function buildErrorContent(err) {
  const errorsShown = trackErrorsShown();
  const manualErrorCount = getManualRetryCount();
  let closeEnabled, retryEnabled, supportEnabled;

  if ((errorsShown && errorsShown >= 2) || (manualErrorCount && manualErrorCount >= 1)) {
    supportEnabled = true;
  } else if (retryEnabled) {
    retryEnabled = true;
  } else {
    closeEnabled = true;
  }

  return {
    ...err,
    msg: err.msg,
    msg2: 'Please try again.',
    support: supportEnabled || false,
    close: closeEnabled || false,
    type: err.message || null,
    retry: {
      enabled: retryEnabled || false,
      method: err.config ? err.config.method : null,
      endpoint: err.config ? err.config.url : null,
    },
  };
}

function handleErrors(err) {
  if (err.response) {
    switch (err.response.status) {
      // Bad Request
      case 400:
        err.response.msg = 'Unable to load content.';
        return buildErrorContent(err.response);

      // Unauthorized
      case 401:
        err.response.msg = 'Authentication Error.';
        return buildErrorContent(err.response);

      // Not Found
      case 404:
        err.response.msg = '404 Not Found.';
        return buildErrorContent(err.response);

      // Request Timeout
      case 408:
        err.response.msg = 'Request Timed Out.';
        return buildErrorContent(err.response);

      // Internal Server Error
      case 500:
        err.response.msg = 'Server Error.';
        return buildErrorContent(err.response);
    }
  } else {
    // Gateway Timeout
    err.request.msg = 'Session Timed Out.';
    return buildErrorContent(err.request);
  }
}
